import React, { useRef, useState } from 'react';
import { hasElementOverflown } from '../../utils/commonUtils';
import Tooltip from '../tooltip/tooltip';
import './style';

const OverflowWrapper = (props) => {
  const {
    children,
    className,
    tooltipProps,
    ...attr
  } = props;

  const elementRef = useRef(null);
  const [isTextOverflow, setIsTextOverflow] = useState(false);
  
  return (
    <div
      role="presentation"
      className={`overflow-ellipsis ${className}`}
      ref={elementRef}
      onMouseEnter={(e) => setIsTextOverflow(hasElementOverflown(e.target))}
      onMouseLeave={() => setIsTextOverflow(false)}
      {...attr}
    >
      {isTextOverflow ?
        (<Tooltip
          content={children}
          {...tooltipProps}
        >
          <div className="overflow-ellipsis">{children}</div>
        </Tooltip>)
        : children}
    </div>
  );
};

export default OverflowWrapper;
